import { useCallback, useState } from 'react';

/**
 * State + safe setters for a (start, step) numbering scheme used to label a
 * fixture sequence (e.g. 100, 110, 120). `updateStartNumber` clamps to a
 * non-negative integer; `updateStepIncrement` clamps to a positive integer so
 * numbering stays strictly increasing. Used by both the create flow
 * (useSequenceDrawing) and view-mode editing (useViewPickPathEditing) to keep
 * coercion behavior consistent.
 */
export function useCustomNumbering(initialStart = 1, initialStep = 1) {
  const [startNumber, setStartNumber] = useState(initialStart);
  const [stepIncrement, setStepIncrement] = useState(initialStep);

  const updateStartNumber = useCallback((value: number) => {
    setStartNumber(Number.isFinite(value) && value >= 0 ? Math.floor(value) : 0);
  }, []);

  const updateStepIncrement = useCallback((value: number) => {
    setStepIncrement(Number.isFinite(value) && value >= 1 ? Math.floor(value) : 1);
  }, []);

  return { startNumber, stepIncrement, setStartNumber, setStepIncrement, updateStartNumber, updateStepIncrement };
}
